'use strict';

function AuthLogoutController($window) {
  var vm = this;

  vm.$onInit = $onInit;

  function $onInit() {
    $window.location.href = '/logout';
  }
}

module.exports = AuthLogoutController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/auth-logout/auth-logout.controller.js
 ** module id = 175
 ** module chunks = 0
 **/